import { cn } from '@mntn/ui-components'

export const SLATE_THEME_CLASSNAME = 'select-app-mfe slate'
export const SELECT_THEME_CLASSNAME = 'select-app-mfe select'

export type Theme = 'select' | 'slate'

export const MfeThemeWrapper = ({
  children,
  className,
  theme = 'slate',
}: {
  children: React.ReactNode
  className?: string
  theme?: Theme
}) => {
  return <div className={cn('select-app-mfe', theme, className)}>{children}</div>
}
